import { render, staticRenderFns } from "./news.vue?vue&type=template&id=14553848&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./news.vue?vue&type=style&index=0&id=14553848&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "14553848",
  "333d2ae8"
  
)

export default component.exports